<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="抽样确定" size="30%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">
          <el-form-item   :readonly="true">
            <span class="title1">总样本数:</span>  <el-input v-model="formData.standardAmount" style="width: 150px;" :readonly="true"/>
          </el-form-item>
          <el-form-item>
            <span class="title1">回访率:</span><el-input v-model="formData.t" disabled="true" style="width: 150px;" :readonly="true"/>
          </el-form-item>
        
          <el-form-item >
            <span class="title1">回访量:</span> <el-input v-model="formData.amount" disabled="true" style="width: 150px;" :readonly="true"/>
          </el-form-item>
          <el-form-item>
            <span class="title1">要求完成回访时间:</span>     
            <el-date-picker
      v-model="value1"
      style="width: 150px;"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
          </el-form-item>
 
          <el-form-item   :readonly="true">
            <span class="title1">指定回访员:</span>  <el-input v-model="formData.standardAmount" style="width: 150px;" :readonly="true">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop=true"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer" style="position: absolute; bottom: 5px; right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="auditBill">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'dataId'],

  created() {
    this.formData.id = this.dataId
  },
  mounted() {
    // this.getData()
  },
  computed: {
    api() {
      return api
    },

    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  watch: {
    // 'formData.adjustAmount': {
    //   handler(n) {
    //     if (!isNaN(n)) {
    //       let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
    //       this.formData.checkAmount = Math.round(number * 100) / 100
    //     }
    //   },
    //   deep: true
    // }
  },
  data() {
    return {
      value1: '',

      formData: {
        remark: null,
        id: null,
        t:'100%',
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {


    // getData() {
    //   this.$http({
    //     url: api.sfCheckBill.getDataUrl,
    //     method: 'post',
    //     data: {id: this.formData.id}
    //   }).then(res => {
    //     let data = res.data.data
    //     this.formData = data
    //     this.picList1 = echoFileFormat(data.proofAttachment1)
    //     this.picList2 = echoFileFormat(data.proofAttachment2)
    //     this.picList3 = echoFileFormat(data.proofAttachment3)
    //   })
    // },





    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    },
    auditBill(){
      this.cancelForm()
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}

::v-deep .el-input-number [role=button] {
    line-height: 26px;
    height: 26px;
    margin-top: 40px;
}
.el-input-number--medium {
    width: 200px;
    display: block;
    line-height: 34px;
}
.title1{
  display: inline-block;
    width: 120px;
    color: #72767b;
    font-size: 13px;
    text-align: end;
    margin: 5px 10px;
}
</style>
